import { type ScanEventProperties } from '~/modules/devices/types/deviceEventCatalog.type';

import { SCAN_ERROR_CODE } from '../constants/scanErrorCode.const';
import { type ScanEvent } from '../types/scanEvent.type';
import { type ScanErrorInfo } from '../types/scanEventTelemetry.type';
import { isScanActionExecutionError, isScanActionResolutionError } from './scanActionError.util';

const MAX_MESSAGE_LENGTH = 500;

export const extractScanErrorInfo = (error: unknown): ScanErrorInfo => {
  const rawMessage = error instanceof Error ? error.message : String(error);
  const errorMessage = rawMessage.slice(0, MAX_MESSAGE_LENGTH);

  if (isScanActionResolutionError(error))
    return { errorCode: SCAN_ERROR_CODE.SCAN_NO_ACTION_MATCHED, errorMessage };
  if (isScanActionExecutionError(error))
    return { errorCode: SCAN_ERROR_CODE.SCAN_ACTION_EXECUTION_FAILED, errorMessage };

  return { errorCode: SCAN_ERROR_CODE.SCAN_ERROR, errorMessage };
};

const toLatencyMs = (detectedAt: string, now: number): number | undefined => {
  const detected = Date.parse(detectedAt);

  return Number.isNaN(detected) ? undefined : now - detected;
};

export const toScanEventProperties = (
  { barcodeValue, correlationId, detectedAt, scanContext }: ScanEvent,
  actionName?: string,
  now: number = Date.now(),
): Omit<ScanEventProperties, 'hostname'> => ({
  barcode_content: {
    barcode_value: barcodeValue,
    order_object_id: scanContext.barcodeContent?.orderObjectId,
    order_shipment_object_id: scanContext.barcodeContent?.orderShipmentObjectId,
    transaction_object_id: scanContext.barcodeContent?.transactionObjectId,
  },
  correlation_id: correlationId,
  event_action: actionName,
  event_action_latency_ms: toLatencyMs(detectedAt, now),
});
